import React from 'react'
import { Card } from 'react-bootstrap'

export default function ReservationsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Reservation Records To Display.
        </h5>
        <div className='my-4'>
          When you have Reservation Records they will appear here.
        </div>
      </Card.Body>
    </Card>
  )
}
